__turbopack_context__.v({
  "button": "styles-module___N7kfG__button",
  "buttonPrev": "styles-module___N7kfG__buttonPrev",
  "container": "styles-module___N7kfG__container",
});
